

export default {

  strConcat(symbol, first, second) {

    let result = first;

    if(second !== ''){
      if(result !== ''){
        result = result + symbol;
      }
      result = result + second;
    }
    return result;
  },
}
